import { render, staticRenderFns } from "./apartment-heading.vue?vue&type=template&id=03dd0d61&"
import script from "./apartment-heading.ts?vue&type=script&lang=ts&"
export * from "./apartment-heading.ts?vue&type=script&lang=ts&"
import style0 from "./apartment-heading.scss?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports